import { h, Component } from 'preact'
import Slider from '@shared/components/Slider'
import Station from '@components/Station'

export default class StationSlider extends Component {
  render (props) {
    const { markers, selectedMarkerIndex, isTouchEnabled, selectedDataset } = props

    const prevStation = markers[selectedMarkerIndex - 1]
    const currentStation = markers[selectedMarkerIndex]
    const nextStation = markers[selectedMarkerIndex + 1]

    const stationProps = {
      allStations: markers,
      selectedDataset: selectedDataset
    }

    const silderProps = {
      onForwardNavigation: () => {
        this.context.actions.selectMarker({ byIndex: selectedMarkerIndex + 1 })
      },
      onBackwardNavigation: () => {
        this.context.actions.selectMarker({ byIndex: selectedMarkerIndex - 1 })
      },
      previousSlide: prevStation && <Station {...stationProps} station={prevStation} selectedStationIndex={selectedMarkerIndex - 1} />,
      currentSlide: <Station {...stationProps} station={currentStation} selectedStationIndex={selectedMarkerIndex} />,
      nextSlide: nextStation && <Station {...stationProps} station={nextStation} selectedStationIndex={selectedMarkerIndex + 1} />,
      canHaveFocus: !isTouchEnabled,
      showSlideButtons: false
    }

    return <div class={props.class}>
      <Slider {...silderProps} />
    </div>
  }
}
